module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/slider_button-69859a9a8035e6427fa6157583c116f4.png";